/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getUrlSync, IActionContext } from '@msdyn365-commerce/core';

/**
 * Syncronously creates an invoice detail page url.
 * @param invoiceId Invoice Id.
 * @param ctx
 */
export function getInvoiceDetailsPageUrlSync(invoiceId: string, ctx: IActionContext): string {
    let url = getUrlSync('invoice-details', ctx) || '';
    url = url.includes('?') ? url.substr(0, url.indexOf('?')) : url;
    return `${url}?invoiceId=${invoiceId}`;
}
